<template>
  <ax-dialog 
    ref="dialog"
    title="Edit Type Curves" 
    icon="mdi-pencil-outline"
    tooltip="Edit type curves" 
    size="medium" 
    :disabled="disabled" 
    @submitted="onSubmit"
  >
    <template slot="content">
      <v-card-text v-if="!isEmpty(options) && !isEmpty(params)">
        <v-container fluid>
          <v-row v-for="type in options" :key="type.value">
            <v-col cols="auto" align-self="center"><span class="text-h4">{{ type.text }}</span></v-col>
            <v-col><v-text-field filled hide-details prefix="qi =" type="number" v-model.number="params[type.text]['Q']" label="Initial production"></v-text-field></v-col>
            <v-col><v-text-field filled hide-details prefix="Di =" type="number" v-model.number="params[type.text]['D']" label="Initial decline"></v-text-field></v-col>
            <v-col><v-text-field filled hide-details prefix="b =" type="number" v-model.number="params[type.text]['B']" label="Hyperbolic exponent"></v-text-field></v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </template>
    <template slot="footer_prefix">
      <ax-button icon="mdi-decimal" tooltip="Round parameters" @clicked="onRound" />
    </template>
    <template slot="submit_text">Save</template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
import AxButton from '@/components/button'
export default {
  name: "dlgEditTypeCurves",
  props: {
    options: { type: Array, required: true },
    params: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  components: {
    AxDialog,
    AxButton
  },
  methods: {
    onRound() {
      Object.keys(this.params).forEach(key => {
        this.params[key]['Q'] = Math.round(this.params[key]['Q'])
        this.params[key]['D'] = Math.round(this.params[key]['D'] * 100) / 100
        this.params[key]['B'] = Math.round(this.params[key]['B'] * 100) / 100
      })
    },
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted', this.params)
    }
  }
}
</script>